<template>
  <div class="graph-container">
    <canvas id="graph" ref="graph" />
  </div>
</template>

<script>
import Chart from 'chart.js'
import { mapGetters } from 'vuex'

export default {
  props: {
    labels: {
      type: Array,
      require: true,
      default: Array
    },
    values: {
      type: Array,
      require: true,
      default: Array
    },
    hours: {
      type: Array,
      require: true,
      default: Array
    },
    price: {
      type: Array,
      require: true,
      default: Array
    },
    formatMoney: {
      type: Function,
      require: false,
      default: Function
    },
    FormatGraphMoney: {
      type: Function,
      require: false,
      default: Function
    }
  },

  computed: {
    ...mapGetters('company', ['defaultCurrency'])
  },

  watch: {
    labels(val) {
      this.update()
    },
    // hours(to, from) {
    //   console.log('hours changed', to)
    // },
    // price(to, from) {
    //   console.log('price changed', to)
    //   this.$forceUpdate();
    // }
  },

  mounted() {
    let self = this
    let context = this.$refs.graph.getContext('2d')
    let options = {
      responsive: true,
      maintainAspectRatio: false,
      tooltips: {
        enabled: true,
        callbacks: {
          label: function(tooltipItem, data) {
            if (tooltipItem.datasetIndex === 0) {
              return 'Total worked: ' + tooltipItem.value + ' h'
            }

            const moneyFormatted = self.FormatGraphMoney(
              tooltipItem.value * 1000 * 100,
              self.defaultCurrency
            )
            return 'Total income: ' + moneyFormatted
          }
        }
      },
      legend: {
        display: false
      }
    }
    let data = {
      labels: this.labels,
      datasets: [
        {
          label: 'Hours Worked',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(230, 254, 249)',
          borderColor: '#040405',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: '#040405',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: '#040405',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,

          data: this.hours
        },
        {
          label: 'Total Earned (in thousands)',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(236, 235, 249)',
          borderColor: 'rgba(88, 81, 216, 1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(88, 81, 216, 1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(88, 81, 216, 1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: this.price.map(x => x / 100 / 1000)
        }
      ]
    }

    this.myLineChart = new Chart(context, {
      type: 'line',
      data: data,
      options: options
    })
  },

  methods: {
    update() {
      this.myLineChart.data.labels = this.labels
      this.myLineChart.data.datasets[0].data = this.hours
      this.myLineChart.data.datasets[1].data = this.price.map(x => x / 100 / 1000)
      this.myLineChart.update({
        lazy: true
      })
    },

    beforeDestroy() {
      this.myLineChart.destroy()
    }
  }
}
</script>

<style scoped>
.graph-container {
  height: 300px;
}
</style>
